import React from 'react'

import { Layout, Row, Section } from '@/components/layout'
import FeaturePageHeader from '@/components/sections/FeaturePageHeader'

const pageId = 'policiesSalesTax'

export default function SalesTax() {
  return (
    <Layout.Content padded>
      <FeaturePageHeader
        subtitle="Sales Tax Policy"
        title="Neat Policies"
        withPricingCta={false}
      />
      <Section paddingTop={32} responsive>
        <Row>
          <div className="policy-text">
            <h3>Tax Rate</h3>
            <p>Your purchases from The Neat Company will be taxed using the applicable sales tax rate for your shipping address. Electronically delivered products (electronically delivered software or services) will be considered shipped to the address you provided as your billing address.</p>
            <p>An estimated sales tax amount will be displayed when orders are placed. The exact sales tax will be calculated and charged at the time your order is shipped.</p>
            <p>Sales tax jurisdictions - based on company or account address</p>
            <p>Sales tax on services like Neat’s varies by jurisdiction. If a jurisdiction considers any of our products as taxable, we’re required to collect and remit sales tax.</p>
            <ul>
              <li>Arizona</li>
              <li>Connecticut</li>
              <li>District of Columbia</li>
              <li>Hawaii</li>
              <li>Indiana</li>
              <li>Illinois</li>
              <li>Kentucky</li>
              <li>Louisiana</li>
              <li>Massachusetts</li>
              <li>Michigan</li>
              <li>New York</li>
              <li>Ohio</li>
              <li>Pennsylvania</li>
              <li>Rhode Island</li>
              <li>South Carolina</li>
              <li>South Dakota</li>
              <li>Tennessee</li>
              <li>Texas</li>
              <li>Utah</li>
              <li>Washington</li>
              <li>West Virginia</li>
            </ul>
            <h3>Tax-Exempt Orders</h3>
            <p>To place an order on behalf of a tax-exempt organization or individual, you will need to provide proof of state tax-exempt status for the state where the product is being shipped. Tax exempt entities do not have to provide documentation for orders shipping to states that do not have sales tax (AK, DE, MT, NH, OR).</p>
            <h4>Instructions for Placing a Tax-Exempt Order:</h4>
            <ul>
              <li>Email your state tax exemption certificate to neatsales@neat.com. The organization or individual name on the order must exactly match the state tax-exempt certificate. Federal tax exemption certificates are not applicable.</li>
              <li>Call The Neat Company at 1-866-632-8732 to place your order.</li>
            </ul>
            <h3>Frequently Asked Questions</h3>
            <h4>What is sales tax?</h4>
            <p>Sales tax is a tax placed on the retail price of merchandise. Retailers are obligated to collect sales tax in any and all states in which they are deemed to have nexus (as determined by physical presence or the conduct of certain activities).</p>
            <h4>Why is The Neat Company charging me sales tax when the company isn’t located in my state?</h4>
            <p>The Neat Company is obligated to collect sales tax in any and all states in which we are deemed to have nexus. For Neat, sales tax treatment is typically determined by the economic nexus threshold for a jurisdiction. In many cases, this is related to the total dollar amount of sales in the prior 12 months (such as $100,000), but in other cases could be a count of unique transactions in that timeframe (such as 100). Once Neat has surpassed these thresholds, it will be required to start collecting and remitting taxes on any sales in that state.</p>
            <h4>What kind proof do I need to provide to place a tax-exempt order?</h4>
            <p>You will need to provide a state tax-exemption certificate. The organization or individual name on the certificate must exactly match the name on the order and the certificate must be valid (i.e. not expired). Federal tax exemption certificates are not applicable.</p>
          </div>
        </Row>
      </Section>

    </Layout.Content>
  )
}

SalesTax.layoutProps = {
  pageId,
}
